import { render } from "./404-error.vue?vue&type=template&id=d48a0d3e&scoped=true"
import script from "./404-error.vue?vue&type=script&lang=js"
export * from "./404-error.vue?vue&type=script&lang=js"

import "./404-error.vue?vue&type=style&index=0&id=d48a0d3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48a0d3e"]])

export default __exports__